import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "30",
  viewBox: "0 0 16 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.4" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.58594 9.06445V19.9549L15.3054 14.5097L8.58594 9.06445Z",
        fill: "#929292"
      }),
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M0.125 19.9909C0.125 15.8587 3.37982 12.4258 9.14302 12.4258V16.6808C9.14302 16.6808 5.40075 15.5384 0.917968 19.9909C0.680164 20.017 0.125 19.9909 0.125 19.9909Z",
        fill: "#929292"
      })
    ], -1)
  ])))
}
export default { render: render }